import { render, staticRenderFns } from "./TopCardFilters.vue?vue&type=template&id=5f32480a&scoped=true"
import script from "./TopCardFilters.vue?vue&type=script&lang=js"
export * from "./TopCardFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f32480a",
  null
  
)

export default component.exports